var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiInsider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mi-insider_svg__mi-insider_svg__Canvas",
    transform: "translate(10771 1863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mi-insider_svg__mi-insider_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mi-insider_svg__mi-insider_svg__Oval"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mi-insider_svg__mi-insider_svg__path0_fill",
    transform: "translate(-10759.2 -1851.23)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mi-insider_svg__mi-insider_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mi-insider_svg__mi-insider_svg__path1_fill",
    transform: "translate(-10764.9 -1856.96)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mi-insider_svg__mi-insider_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mi-insider_svg__mi-insider_svg__path2_fill",
    transform: "translate(-10771 -1863)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mi-insider_svg__mi-insider_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 2.22727 4.45455C 3.45736 4.45455 4.45455 3.45736 4.45455 2.22727C 4.45455 0.997184 3.45736 0 2.22727 0C 0.997184 0 0 0.997184 0 2.22727C 0 3.45736 0.997184 4.45455 2.22727 4.45455Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mi-insider_svg__mi-insider_svg__path1_fill",
    fillRule: "evenodd",
    d: "M 7.92518 15.8501C 4.71984 15.8501 1.83011 13.9193 0.603482 10.9579C -0.623149 7.99657 0.0548759 4.58791 2.32139 2.32139C 4.58791 0.0548758 7.99658 -0.623149 10.9579 0.603482C 13.9193 1.83011 15.8501 4.71984 15.8501 7.92518C 15.846 12.3003 12.3003 15.846 7.92518 15.8501ZM 7.92446 2.30139C 4.81859 2.30139 2.30078 4.8192 2.30078 7.92507C 2.30078 11.0309 4.81859 13.5487 7.92446 13.5487C 11.0303 13.5487 13.5481 11.0309 13.5481 7.92507C 13.5238 4.83535 11.0143 2.34235 7.92446 2.33839L 7.92446 2.30139Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mi-insider_svg__mi-insider_svg__path2_fill",
    fillRule: "evenodd",
    d: "M 14 28C 6.26801 28 0 21.732 0 14C 0 6.26801 6.26801 0 14 0C 21.732 0 28 6.26801 28 14C 27.9918 21.7286 21.7286 27.9918 14 28ZM 13.9998 2.87854C 7.86975 2.87854 2.90039 7.8479 2.90039 13.9779C 2.90039 20.1079 7.86975 25.0773 13.9998 25.0773C 20.1298 25.0773 25.0991 20.1079 25.0991 13.9779C 25.0991 7.8479 20.1298 2.87854 13.9998 2.87854Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiInsider);
export default __webpack_public_path__ + "static/media/mi-insider.ebaba40242f3ac985c677bd13ea4d920.svg";
export { ForwardRef as ReactComponent };